import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-school',
	templateUrl: './icon-school.component.svg',
})
export class IconSchoolComponent {}
